import React, {
    useCallback, useState, useEffect, useMemo
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { MetadataForm } from '@jutro/legacy/uiconfig';

import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from 'wmic-digital-auth-react';

import metadata from './CreateNote.metadata.json5';
import styles from './CreateNote.module.scss';

function CreateNote(props) {
    const { authHeader } = useAuthentication();
    const { ClaimService } = useDependencies('ClaimService');
    const [isValid, setIsValid] = useState(false);
    const [note, updateNote] = useState({
        subject: '',
        body: ''
    });
    const { match, history } = props;
    const onValidationChange = useCallback((newIsValid) => {
        setIsValid(newIsValid);
    }, []);

    const writeValue = useCallback(
        (value, path) => {
            const clonsedNote = _.clone(note);
            _.set(clonsedNote, path, value);
            updateNote(clonsedNote);
        },
        [note]
    );

    const redirectToPreviousState = useCallback(() => {
        const {
            location: {
                state: { redirectPath }
            }
        } = history;
        const nextPath = `/claims/${match.params.claimNumber}`;
        history.push({
            pathname: nextPath,
            state: {
                redirectPath,
                selectedTab: 'notesTab'
            }
        });
    }, [history, match]);

    const handleSave = useCallback(() => {
        return ClaimService.createClaimNote(match.params.claimNumber, note, authHeader).then(() => {
            redirectToPreviousState();
        });
    }, [ClaimService, authHeader, match, note, redirectToPreviousState]);

    const onBackClicked = useCallback(
        (e) => {
            e.preventDefault();
            redirectToPreviousState();
        },
        [redirectToPreviousState]
    );

    const readValue = useCallback(
        (id, path) => {
            return _.get(note, path);
        },
        [note]
    );

    const overrides = useMemo(
        () => ({
            '@field': {
                onValueChange: writeValue
            },
            saveBtnId: {
                disabled: !isComponentValid
            }
        }),
        [isComponentValid, writeValue]
    );

    const resolvers = useMemo(
        () => ({
            resolveValue: readValue,
            resolveCallbackMap: {
                handleSave: handleSave,
                handleCancel: redirectToPreviousState,
                onBackClicked: onBackClicked
            },
            resolveClassNameMap: styles
        }),
        [handleSave, onBackClicked, readValue, redirectToPreviousState]
    );

    return (
        <div className={styles.createNote}>
            <MetadataForm uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} onValidationChange={onValidationChange} />
        </div>
    );
}

CreateNote.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            summarystate: PropTypes.shape({}).isRequired
        }).isRequired
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            claimNumber: PropTypes.string
        })
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string
            })
        })
    }).isRequired
};
export const CreateNoteComponent = CreateNote;
export default withRouter(CreateNote);
